import { render, staticRenderFns } from "./PosManageService.vue?vue&type=template&id=34f2f592&scoped=true&"
import script from "./PosManageService.vue?vue&type=script&lang=js&"
export * from "./PosManageService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2f592",
  null
  
)

export default component.exports